angular.
module("dx.webapp.rubrics").
controller("DxRubricsRouteController", function RubricsRouteController(
	DX_URLS,
	dxRubricsRepository
) {
	"use strict";

	this.Urls = DX_URLS;

	this.dxRubricsRepository = dxRubricsRepository;
	this.dxRubricsRepository.loadDefault();

	this.listHasRubrics = function listHasRubrics() {
		return dxRubricsRepository.items.some(function notArchived(element) {
			return !element.isArchived;
		});
	};
});
